import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { downgradeQueryFn } from './queryFn/downgrade.query';
import { getDowngradeDetailsQueryFn } from './queryFn/getDowngradeDetails/getDowngradeDetails.query';
export const DowngradeQueriesConfig = createQueriesConfig({
  getDowngradeDetails: {
    queryFn: getDowngradeDetailsQueryFn
  },
  downgrade: {
    queryFn: downgradeQueryFn
  }
});
//# sourceMappingURL=downgrade.queries.js.map